import api from '../api';

export default class GenericService {
  static async getRelationShip(props?: { benef?: boolean; resp?: boolean }) {
    const { data } = await api.get<{
      content: {
        id: number;
        name: string;
        needLegalGuardian?: boolean;
        needRespLegal?: boolean;
        typeKinship?: 'RESP' | 'BENEF';
      }[];
    }>('/generic/relationship');
    const { content } = data;
    if (props?.benef && props?.resp) return content;
    if (props?.benef)
      return content.filter((item) => item.typeKinship === 'BENEF');
    if (props?.resp)
      return content.filter((item) => item.typeKinship === 'RESP');
    return content;
  }
}
